<template>
  <div>
    <v-toolbar class="flex-grow-0" flat>
      <v-toolbar-title class="headline ml-3">
        {{ dialogHeader }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-select
        :value="bookingType"
        :items="bookingTypes"
        :disabled="isExistingBooking"
        dense
        outlined
        hide-details
        class="mr-3"
        style="max-width: 200px;"
        @input="setBookingType"
      ></v-select>

      <booking-form-settings></booking-form-settings>

      <v-btn
        icon
        class="d-flex d-lg-none"
        @click="close"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-alert
      v-if="isBookVisitBooking"
      type="warning"
      text
      dense
      icon="mdi-cloud-sync"
      class="mx-4 mt-4 mb-0"
    >
      Detta är en BookVisit bokning - ändringar kan skrivas över av BookVisit
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import BookingFormSettings from '@/components/booking/form/FormSettings.vue'

export default {
  name: 'BookingFormHeaderSection',
  components: {
    BookingFormSettings
  },
  computed: {
    ...mapState('bookingForm', {
      bookingType: 'bookingType'
    }),
    ...mapGetters('bookingForm', {
      bookingTypes: 'bookingTypeOptions',
      dialogHeader: 'dialogHeader',
      isBookVisitBooking: 'isBookVisitBooking',
      isExistingBooking: 'isExistingBooking'
    })
  },
  methods: {
    ...mapActions('bookingForm', {
      updateBookingType: 'setBookingType',
      setShowFormDialog: 'setShowFormDialog'
    }),
    setBookingType: function (bookingType) {
      return this.updateBookingType(bookingType)
    },
    close: function () {
      return this.setShowFormDialog(false)
    }
  }
}
</script>
